"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppCountryCode = void 0;
function getAppCountryCode(url) {
    const appCountryCode = url.searchParams.get("acc");
    return appCountryCode || null;
}
exports.getAppCountryCode = getAppCountryCode;
//# sourceMappingURL=country.js.map